import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

//解决vue路由重复导航错误
//获取原型对象上的push函数
const originalPush = VueRouter.prototype.push
//修改原型对象中的push方法
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  {
    path: '/',
    name: 'home',
    // component: HomeView
    component: () => import('../views/index'),
    redirect: '/home',//默认进入首页
    children: [
      // 首页
      {
        path: '/home',
        name: 'home',
        component: () => import('../views/home/index.vue')
      },
      //服务
      {
        path: '/serve',
        name: 'serve',
        component: () => import('../views/serve/index.vue')
      },
      //产品
      {
        path: '/products',
        name: 'products',
        component: () => import('../views/products/index.vue')
      },
      //新闻资讯
      {
        path: '/news',
        name: 'news',
        component: () => import('../views/news/index.vue')
      },
      //关于我们
      {
        path: '/aboutUs',
        name: 'aboutUs',
        component: () => import('../views/aboutUs/index.vue')
      },
      //联系我们
      {
        path: '/contactUs',
        name: 'contactUs',
        component: () => import('../views/contactUs/index.vue')
      },
      //  客户案例部分
      {
        path: '/customerIntroduction',
        name: 'customerIntroduction',
        component: () => import('../views/customerIntroduction/index.vue')
      }
    ]
  },
  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  // }
]

const router = new VueRouter({
  routes
})

export default router
